// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  name: 'qa',
  production: false,
  region: 'NA',
  appUrl: 'manage-zones.qa.zonarsystems.net',
  apiBase: {
    url: 'https://api.zonarsystems.net/core/v1/settings',
  },
  coreEntityApiBase: {
    url: 'https://api-qa.zonarsystems.net/core/v1',
  },
  userPreferenceApiBase: {
    url: 'https://api-qa.zonarsystems.net/alert/v1',
  },
  authEnv: 'qa',
  auth: {
    clientID: 'jtnPLsVOANe12wAF7Tvpni6yBe7MTYvz',
    domain: 'qa-login.zonarsystems.net',
    audience: 'http://apiqa.zonarsystems.net/',
    applicationId: '70f83b5c-8d15-477a-ae54-6586b3a74127',
    defaultZonarRole: 'bd10573b-edc2-40e2-b5c5-36afd2bdbc2b',
    useRefreshTokens: true,
  },
  pendo: {
    url: 'https://cdn.pendo.io/agent/static/',
    key: '47e63a49-4477-47c2-4ea6-0f032e1785d5',
  },
  googleTagManager: {
    id: 'GTM-PM9R42P',
    auth: '2KLWSiRQSUBTl0bsYimfIQ',
    environment: 'env-4',
  },
  googleOptimize: {
    gOptId: null,
    powerOnAbTestId: null,
  },
  datadog: {
    enabled: true,
    applicationId: 'c600f2b7-494c-4e18-afc6-439707bcc61c',
    clientToken: 'pub9209625fca6265b4ba1bae7620e0f7b4',
    siteUrl: 'us5.datadoghq.com',
    tagEnvironment: 'qa',
  },
  i18n: {
    supportedLanguages: ['en', 'en-GB', 'de', 'es', 'fr', 'it'],
    defaultLanguage: 'en',
  },
  devCycle: {
    clientId: 'dvc_client_3a03d1aa_1354_432c_af11_23757d5b2e7a_f7b1a96',
  },
  apiKeyV3: 'K9sFEK271qD8JFibP_1Dk9u2IQqiTXsxsv9T11PaKng',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
